import { Grid, Paper, Typography, Box, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { procurementApi } from '../../api/procurement.api';

function Stat({ label, value }: { label: string; value: string | number }) {
  return (
    <Grid item>
      <Paper sx={{ p: 2, minWidth: 150, textAlign: 'center' }}>
        <Typography variant="h6">{value}</Typography>
        <Typography variant="caption">{label}</Typography>
      </Paper>
    </Grid>
  );
}

export function ProcurementDashboardPage() {
  const { data } = useQuery({ queryKey: ['procurement-dashboard'], queryFn: procurementApi.dashboard });
  const inr = (n = 0) => `₹${n.toLocaleString()}`;

  return (
    <>
      <PageHeader title="Procurement Dashboard & Analytics" />
      <Grid container spacing={1} mb={3}>
        <Stat label="PR Value (est.)" value={inr(data?.prValue)} />
        <Stat label="PO Value" value={inr(data?.poValue)} />
        <Stat label="Pending Procurement" value={data?.pendingProcurement ?? 0} />
        <Stat label="Cost Saving" value={inr(data?.costSaving)} />
        <Stat label="Procurement TAT (days)" value={data?.procurementTatDays ?? 0} />
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle2" gutterBottom>Material Aging (awaiting receipt)</Typography>
          <Paper sx={{ p: 2 }}>
            {Object.entries(data?.materialAging ?? {}).map(([bucket, n]) => (
              <Box key={bucket} display="flex" justifyContent="space-between"><span>{bucket} days</span><strong>{n as number}</strong></Box>
            ))}
          </Paper>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography variant="subtitle2" gutterBottom>Vendor Performance (top by PO value)</Typography>
          <Paper>
            <Table size="small">
              <TableHead><TableRow><TableCell>Vendor ID</TableCell><TableCell>PO Count</TableCell><TableCell>PO Value</TableCell></TableRow></TableHead>
              <TableBody>
                {(data?.vendorPerformance ?? []).map((v) => (
                  <TableRow key={v.vendorId}><TableCell>{v.vendorId}</TableCell><TableCell>{v.poCount}</TableCell><TableCell>{inr(v.poValue)}</TableCell></TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
